import { render } from "./WizardCompletionCircle.vue?vue&type=template&id=cb5c3a72"
import script from "./WizardCompletionCircle.vue?vue&type=script&lang=js"
export * from "./WizardCompletionCircle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__